import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import styled from "styled-components";
import ItemImage from "@sprout/client-components/dist/ItemImage";
import { Flex } from "sprout-ui-primitives";
import { media } from "sprout-ui-theme";
import UrlLink from "@sprout/client-components/dist/UrlLink";
const Anchor = styled(UrlLink)`
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow-wrap: break-word;
  word-wrap: break-word;

  ${media.target("pointer")} {
    &:hover {
      text-decoration: underline;
    }
  }
`;
const AnchorImage = styled(UrlLink)`
  flex: none;
`;
const ActivityMetadata = (props)=>{
    const { ogUrl , ogTitle , ogImage , type  } = props;
    return /*#__PURE__*/ _jsxs(Flex, {
        align: "center",
        mt: "6px",
        children: [
            /*#__PURE__*/ _jsx(AnchorImage, {
                url: ogUrl,
                children: /*#__PURE__*/ _jsx(ItemImage, {
                    size: 40,
                    src: ogImage || undefined,
                    type: type
                })
            }),
            ogTitle && /*#__PURE__*/ _jsx(Anchor, {
                fontSize: 1,
                ml: "8px",
                url: ogUrl,
                children: ogTitle
            })
        ]
    });
};
export default ActivityMetadata;
